import styled, { createGlobalStyle } from "styled-components";

export const ContentWrapper = styled.div`
  padding: 0 24px;

  .scrollable-wrapper.withScroll .anticon.arrow-up {
    top: -12px;
    right: -3px;
  }

  .project-name {
    margin-right: 8px;
    color: ${"#595959"};
    font-weight: 600;
    font-size: 10px;
    text-transform: uppercase;
  }
`;

export const CommentDrawerDocumentsCollapseWrapper = styled.div`
  > .ant-collapse {
    margin: 0;

    .ant-collapse-item {
      > .ant-collapse-header {
        padding: 0;

        > .ant-collapse-arrow {
          position: absolute;
          right: 0;
          margin: 0;
        }

        > div .ant-typography {
          margin: 0;
          font-size: 14px;
          line-height: 24px;
          font-weight: 500;
          color: ${"#1677ff"};
        }
      }

      > .ant-collapse-content > .ant-collapse-content-box {
        > .ant-row > .ant-col > .ant-typography.document-version-text {
          margin: 0;
          text-align: end;
          font-size: 12px;
          line-height: 20px;
          font-weight: 500;
          color: ${"#8c8c8c"};
        }

        > .ant-row:not(:last-child) {
          margin-bottom: 12px;
        }
      }
    }

    .ant-divider {
      margin: 8px 0;
    }

    .documents-row {
      > .ant-col > .anticon {
        display: block;

        > svg {
          color: ${"#1677ff"};
          height: 16px;
          width: 16px;
        }
      }

      .documents-text {
        color: ${"#1677ff"};
      }
    }
  }
`;

export const GlobalDrawerStyles = createGlobalStyle`
  .ant-drawer.comment-drawer.in-work-comment-drawer .ant-drawer-body {
    display: flex;
    flex-direction: column;
  }
`;
